const sharetribeSdk = require('sharetribe-flex-sdk');
// import { indexOf } from 'core-js/core/array';
import { getMasterCalendarPlan } from './getMasterCalendarPlan';
import { types as sdkTypes } from '../util/sdkLoader';

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

  const { UUID } = sdkTypes;
  

 export const updateServicesCalendar = (sortedValues) => {
   
     return getMasterCalendarPlan().then(resp => {
      const masterId = resp.id.uuid;
      const availabilityExArray = [];
      const intermArray = [];
      const finalAvailabilityArray = [];

      const receivedProps = Object.entries(sortedValues);
      receivedProps.forEach(item => {
        if(item[0] !== "timezone"){
          intermArray.push(item);
        }
      })
      intermArray.forEach(item => {
        if(item[1].length !== 0){
          finalAvailabilityArray.push(item)
        }
      })
console.log(finalAvailabilityArray)
      finalAvailabilityArray.forEach(item => {
        console.log(item[1][0]["endTime"])
        console.log(typeof item[1][0]["endTime"])
        availabilityExArray.push({
          "dayOfWeek": item[0],
          "seats": 1,
          "startTime": item[1][0]["startTime"],
          "endTime": item[1][0]["endTime"] === "24:00" ? "00:00" : item[1][0]["endTime"]  //TODO remember that sdk.ownListings.update does not accept "24:00 as hour format", but "00:00" instead 
      })
      })

      console.log("$$$$$$$$$$$$$44")
   console.log(sortedValues.timezone)
              return sdk.ownListings.query({}).then(resp => {
                    const listingsArray = resp.data.data;
                    listingsArray.forEach(listing=> {
                              sdk.ownListings.update({
                                id: new UUID(listing.id.uuid),
                                availabilityPlan: {
                                      type: "availability-plan/time",
                                      timezone: sortedValues.timezone,
                                      entries: availabilityExArray
                                  }
                            }).catch(error => {
                              console.log(error)
                          });
                    })
              }).catch(error => {
                console.log(error)
            });
     }).catch(error => {
      console.log(error)
  });

  }
 